<app-base-product-details id="app-base-product-details">
  <ng-container *ngFor="let association of product?.associations">
    <div *ngIf="association?.associated_products?.length" class="section-settings related-items custom-owl-nav">
      <div class="container">
        <div class="section-head">
          <h3 class="section-title h3--custom">
            {{association | translate: 'name'}}
          </h3>
        </div>
        <!--End Section-head-->
        <div class="section-content">
          <owl-carousel [carouselClasses]="['owl-theme', 'owl-flex']" [options]="changeCarouselOptions(bestsellersOption,{
              responsive : {
                nav: true,
              '0': {
                stagePadding: 7,
                items: 1,
                autoplay:true,
                transitionStyle : 'fade'
              },
              '480': {
                stagePadding: 7,
                items: 2, 
                autoplay:true,
                transitionStyle : 'fade'
              },
              '768': {
                stagePadding: 7,
                items: 3, 
                autoplay:true,
                transitionStyle : 'fade'
              },
              '992': {
                nav: true,
                items: 4, 
                autoplay:true,
                transitionStyle : 'fade'
              }
            }
          })">
            <div *ngFor="let product of association?.associated_products;let first = first;let last = last;"
              [ngClass]="{first: first, last: last}" class="item">
              <app-product *ngIf="product" [product]="product"></app-product>
            </div>
          </owl-carousel>
        </div>
        <!--End Section-content-->
      </div>
      <!--End Container-->
    </div>
    <!--End related-->
  </ng-container>
</app-base-product-details>